<section class="content profile-page">
  <div class="block-header">
      <div class="container">
          <div class="row ">
              <div class="col-md-12  p-0">
                  <h2 class="poppins font-weight-bold pl-2"> Order Receipt</h2>
              </div>
              <div class=" col-md-5 px-6 col-sm-12 p-0">

                  <div class="breadcrumb flat">
                    <a [routerLink]="['/pos']"> Home</a>
      <a [routerLink]="['/pos/orderreceipt/manage']">Manage Order Receipt</a>
      <a href="#" class="active"> New Order Receipt</a>
                  </div>
              </div>
              <div class="col-md-7">
                  <!-- <div class="float-right">
                    <button class="box-button mr-3" [routerLink]="['/pos/orderreceipt/new']">New Order Receipt</button>
                      <button class="box-button" [routerLink]="['/pos/orderreceipt/manage']">Manage
                        Order Receipt</button>


                  </div> -->
              </div>
          </div>
      </div>

  </div>
  <div class="container">
      <div class="row">
          <div class="col-md-12 p-0">
              <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                  <div class="row mx-0">
                      <div class="col-md-12" >
                          <h4 class="font-weight-bold">View Order Receipt Details</h4>
                      </div>
                     


                  </div> 
                      <div class="row mx-0">
                        <div class="col-md-7">
                          <div class="row  border-bottom p-1 m-3">
                            <div class="col-4 p-0">Order Receipt Id</div>
                             
                            <div class="col-7 p-0">{{rows.id}}</div>
                          </div>
                          <div class="row  border-bottom p-1 m-3">
                            <div class="col-md-4  p-0"> Pos Subscription Id</div>
                             
                            <div class="col-7 p-0">{{rows.posSubscriptionId}}</div>
                          </div>
                          <div class="row  border-bottom p-1 m-3">
                            <div class="col-md-4  p-0">Add Noof BlankLine Top Of Receipt</div>
                             
                            <div class="col-7 p-0"> {{rows.addNoofBlankLineTopOfReceipt}}</div>
                          </div>
                          <div class="row  border-bottom p-1 m-3">
                            <div class="col-4 p-0"> Order Number Type</div>
                             
                            <div class="col-7 p-0">{{rows.orderNumberType}}</div>
                          </div>
                          <div class="row  border-bottom p-1 m-3">
                            <div class="col-4 p-0"> OrderNumber RollOver After</div>
                             
                            <div class="col-7 p-0">{{rows.orderNumberRollOverAfter}}</div>
                          </div>
      
                          <div class="row  border-bottom p-1 m-3">
                          <div class="col-4 p-0"> Use Large Fond</div>
                           
                          <div class="col-7 p-0">
                            <!-- {{rows.UseLargeFond}} -->
                            <input type="checkbox"  [(ngModel)]="rows.useLargeFond" id="UseLargeFond" name="UseLargeFond" >
                          </div>
      
                        </div>
                        <div class="row  border-bottom p-1 m-3">
                          <div class="col-md-4  p-0"> Order Notes</div>
                           
                          <div class="col-7 p-0">
                           
                            <input type="checkbox"  [(ngModel)]="rows.orderNotes" id="OrderNotes" name="OrderNotes" >
                          </div>
                        </div>
                        <div class="row  border-bottom p-1 m-3">
                          <div class="col-md-4  p-0">User Alternative Inventory Name</div>
                           
                          <div class="col-7 p-0"> 
                            <!-- {{rows.UserAlternativeInventoryName}} -->
                            <input type="checkbox"  [(ngModel)]="rows.userAlternativeInventoryName" id="UserAlternativeInventoryName" name="UserAlternativeInventoryName" >
                          </div>
                        </div>
                        <div class="row  border-bottom p-1 m-3">
                          <div class="col-4 p-0"> GroupLineItems</div>
                           
                          <div class="col-7 p-0">
                          
                            <input type="checkbox"  [(ngModel)]="rows.groupLineItems" id="GroupLineItems" name="GroupLineItems" >
                          </div>
                        </div>
                        <div class="row  border-bottom p-1 m-3">
                          <div class="col-4 p-0"> ShowModifierName</div>
                           
                          <div class="col-7 p-0">
                              <input type="checkbox"  [(ngModel)]="rows.showModifierName" id="ShowModifierName" name="ShowModifierName" >
                          </div>
                        </div>
      
                        <div class="row  border-bottom p-1 m-3">
                        <div class="col-4 p-0"> Group Modifiers</div>
                         
                        <div class="col-7 p-0">
                            <input type="checkbox"  [(ngModel)]="rows.groupModifiers" id="GroupModifiers" name="GroupModifiers" >
      
                        </div>
                      </div>
                      <div class="row  border-bottom p-1 m-3">
                        <div class="col-md-4  p-0"> Show CustomerInfo</div>
                         
                        <div class="col-7 p-0">
                            <input type="checkbox"  [(ngModel)]="rows.showCustomerInfo" id="ShowCustomerInfo" name="ShowCustomerInfo" >
      
                        </div>
                      </div>
                      <div class="row  border-bottom p-1 m-3">
                        <div class="col-md-4  p-0">SmsReceipt</div>
                         
                        <div class="col-7 p-0"> 
                            <input type="checkbox"  [(ngModel)]="rows.smsReceipt" id="SmsReceipt" name="SmsReceipt" >
      
                        </div>
                      </div>
                      <div class="row  border-bottom p-1 m-3">
                        <div class="col-4 p-0">Email Receipt</div>
                         
                        <div class="col-7 p-0">
                            <input type="checkbox"  [(ngModel)]="rows.emailReceipt" id="EmailReceipt" name="EmailReceipt" >
      
                        </div>
                      </div>
                      
                          
                       
                          <div class="text-right pt-2">
                            <button class="box-button" id="accountDataList"
                              [routerLink]="['/pos/orderreceipt/manage']">Back</button>
                          </div>
                        
                        </div>
                          <div class="col-md-5">
                              <div class="b">
                                  <img src="assets/img/payment-solutions.png" alt="Tips"
                                      style="display: block; width: 100%;">
                              </div>

                          </div>



                      </div> 
              </div>
          </div>
      </div>
  </div>
</section>
 